import { lazy, useCallback } from 'react';
import { Modal } from '@client/components/globals/Modal';
import { Loader } from '@client/components/common/Loader';

const ShareModalLoader = lazy(() => import(/* webpackPrefetch: true */ './ShareModal'));

export const useShareShow = (showId: string) => useCallback(() => Modal.show({
  title: 'Share',
  buttons: [],
  body: (
    <Loader
      load={ShareModalLoader}
      showId={showId}
    />
  ),
}), [showId]);
